import { Facebook, Instagram, Youtube, MessageCircle, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import logo from "@/assets/logo.png";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground text-background py-10 sm:py-12" role="contentinfo">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Logo and Description */}
          <div>
            <img src={logo} alt="LS Dental Clinic Logo" className="h-12 w-auto mb-4 brightness-0 invert" width={120} height={48} loading="lazy" decoding="async" />
            <p className="text-sm text-background/70">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <nav aria-label="Footer navigation">
            <h3 className="font-bold text-lg mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2 text-sm text-background/70">
              <li>
                <a href="/" className="hover:text-primary transition-colors">
                  {t('nav.home')}
                </a>
              </li>
              <li>
                <a href="/our-clinic" className="hover:text-primary transition-colors">
                  {t('nav.ourClinic')}
                </a>
              </li>
              <li>
                <a href="/#treatments" className="hover:text-primary transition-colors">
                  {t('nav.dentalTreatments')}
                </a>
              </li>
              <li>
                <a href="/our-team" className="hover:text-primary transition-colors">
                  {t('nav.ourTeam')}
                </a>
              </li>
              <li>
                <a href="/#contact" className="hover:text-primary transition-colors">
                  {t('nav.contact')}
                </a>
              </li>
            </ul>
          </nav>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-2 text-sm text-background/70">
              <li>Playas del Coco, Guanacaste</li>
              <li>Costa Rica</li>
              <li>
                <a href="tel:+18336484745" className="hover:text-primary transition-colors font-semibold" aria-label="Call toll-free number +1 833-648-4745">
                  +1 833-648-4745 {t('footer.tollFree')}
                </a>
              </li>
              <li>
                <a href="tel:+50626702400" className="hover:text-primary transition-colors" aria-label="Call local number +506 2670-2400">
                  +506 2670-2400
                </a>
              </li>
              <li>
                <a href="https://wa.me/50683541716" className="hover:text-primary transition-colors flex items-center gap-2" aria-label="Contact us on WhatsApp at +506 8354-1716">
                  <MessageCircle className="w-4 h-4" aria-hidden="true" />
                  +506 8354-1716 (WhatsApp)
                </a>
              </li>
              <li>
                <a href="mailto:internationalpatients@lsdentalcostarica.com" className="hover:text-primary transition-colors" aria-label="Email us at internationalpatients@lsdentalcostarica.com">
                  internationalpatients@lsdentalcostarica.com
                </a>
              </li>
              <li className="flex items-center gap-2 pt-2">
                <Clock className="w-4 h-4" aria-hidden="true" />
                {t('contact.info.hoursValue')}
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a
                href="https://facebook.com/LsDentalClinic"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors"
                aria-label="Visit LS Dental Clinic on Facebook"
              >
                <Facebook className="w-5 h-5" aria-hidden="true" />
              </a>
              <a
                href="https://www.instagram.com/lsdentalclinic/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors"
                aria-label="Visit LS Dental Clinic on Instagram"
              >
                <Instagram className="w-5 h-5" aria-hidden="true" />
              </a>
              <a
                href="https://www.youtube.com/@lsdentalcliniccostarica1928"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors"
                aria-label="Visit LS Dental Clinic on YouTube"
              >
                <Youtube className="w-5 h-5" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background/20 pt-8 text-center text-sm text-background/70">
          <p>&copy; {new Date().getFullYear()} LS Dental Clinic. {t('footer.allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
